import { gql } from 'graphql-tag';

const GET_UNIVERSITIES = gql`
	query getUniversities(
		$product: Product
		$name: String
		$typeIds: [Int] = null
		$locationIds: [Int]
		$page: Int
		$limit: Int = 20
		$offset: Int
	) {
		universities(
			product: $product
			name: $name
			type_ids: $typeIds
			location_ids: $locationIds
			page: $page
			limit: $limit
			offset: $offset
		) {
			data {
				id
				name
				logo
				paid_features
				stats {
					recommended_percentage
				}
				saved
				slug
				privacy_policy_url
				order
				undergraduate: profile(product: UNDERGRADUATE) {
					external_url
					external_prospectus_url
					cover_image
					external_events_url
				}
				postgraduate: profile(product: POSTGRADUATE) {
					external_url
					external_prospectus_url
					cover_image
					external_events_url
				}
			}
			filters {
				name
				values {
					id
					count
				}
			}
			per_page
			current_page
			has_more_pages
			total
		}
	}
`;

const GET_CLEARING_UNIVERSITIES = gql`
	query getClearingUniversities(
		$name: String
		$typeIds: [Int]
		$locationIds: [Int]
		$page: Int
		$limit: Int = 20
		$fromStart: Boolean
	) {
		clearingUniversities(
			name: $name
			type_ids: $typeIds
			location_ids: $locationIds
			page: $page
			limit: $limit
			from_start: $fromStart
		) {
			data {
				id
				name
				logo
				paid_features
				recommended_percentage
				external_url
				privacy_policy_url
				phone_number
				saved
				slug
				cover_image
				order
			}
			filters {
				name
				values {
					id
					count
				}
			}
			per_page
			current_page
			has_more_pages
			total
		}
	}
`;

export { GET_UNIVERSITIES, GET_CLEARING_UNIVERSITIES };
